import { FC } from 'react';
import { useRouter } from 'next/router';
import { UiButton, UiIcon, UiTitle } from '@frontend/znanie-uikit';

import { useMediaQueries } from 'hooks/utils/useMediaQueries';

import { statusMap } from './AppliedNotification.const';

import * as T from './AppliedNotification.types';

import css from './AppliedNotification.module.scss';

export const BecomeSpeakerAppliedNotification: FC<
  T.IAppliedNotificationProps
> = ({ status }) => {
  const router = useRouter();
  const { isTabletOrDesktop } = useMediaQueries();

  if (status === null) {
    return null;
  }

  const statusItem = statusMap[status];

  return (
    <div className={css.container}>
      <div className={css.contentWrapper}>
        <UiIcon
          name={statusItem.iconName}
          color={statusItem.iconColor}
          width={80}
          height={80}
        />
        <UiTitle
          as="h2"
          align="center"
          size={isTabletOrDesktop ? 'big' : 'large'}
          className={css.title}
        >
          {`Вы уже подавали заявку «Стать лектором».
          Текущий статус:`}{' '}
          <span className={css[statusItem.color]}>{statusItem.name}</span>
        </UiTitle>

        <UiButton
          variant="outline"
          onClick={() => router.push('/profile/main')}
        >
          Перейти в личный кабинет
        </UiButton>
      </div>
    </div>
  );
};
